import { Controller } from 'stimulus';
import axios from 'axios';
import { template } from 'lodash';

export default class extends Controller {
  static targets = ['companyOwnerListTemplate', 'companyOwnerListContainer'];

  connect() {
    this.appliedDaysFilter = '0-7days';
    this.appliedLastLoginFilter = 'logged_in';

    this.daysFilters = {
      '0-7days': {
        label: '7 Days',
        value: 7,
      },
      '7-15days': {
        label: '15 Days',
        value: 15,
      },
      '15-30days': {
        label: '30 Days',
        value: 30,
      },
    };
    this.lastLoginFilters = {
      logged_in: {
        value: 'Logged in',
      },
      not_logged_in: {
        value: 'Not Logged in',
      },
    };
    this.fetchCompanyOwnersLoginStats(
      this.daysFilters[this.appliedDaysFilter].value,
      this.lastLoginFilters[this.appliedLastLoginFilter].value
    );
    this.requesting = false;
  }

  changeDaysFilter(e) {
    e.preventDefault();
    this.appliedDaysFilter = e.target.dataset.filter;
    this.fetchCompanyOwnersLoginStats(
      this.daysFilters[this.appliedDaysFilter].value,
      this.lastLoginFilters[this.appliedLastLoginFilter].value
    );

    const buttons = e.target.parentElement.getElementsByTagName('button');
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].classList.remove('btn-primary');
      buttons[i].classList.add('btn-outline-primary');
    }
    e.target.classList.add('btn-primary');
    e.target.classList.remove('btn-outline-primary');
  }

  changeLastLoginFilter(e) {
    e.preventDefault();
    this.appliedLastLoginFilter = e.target.dataset.filter;

    this.fetchCompanyOwnersLoginStats(
      this.daysFilters[this.appliedDaysFilter].value,
      this.lastLoginFilters[this.appliedLastLoginFilter].value
    );

    const buttons = e.target.parentElement.getElementsByTagName('button');
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].classList.remove('btn-primary');
      buttons[i].classList.add('btn-outline-primary');
    }
    e.target.classList.add('btn-primary');
    e.target.classList.remove('btn-outline-primary');
  }

  fetchCompanyOwnersLoginStats(dayFilter, lastLoginFilter) {
    this.template = template(this.companyOwnerListTemplateTarget.innerHTML);
    const url = `/api/v1/company_owners`;
    const params = {
      page: 1,
      from_time: dayFilter,
      last_login: lastLoginFilter,
    };
    this.requesting = true;
    this.companyOwnerListContainerTarget.innerHTML = '';
    axios.get(url, { params }).then((response) => {
      this.requesting = false;
      response.data.map((result) => {
        this.companyOwnerListContainerTarget.innerHTML += this.template(result);
      });
    });
  }
}
